import { Component } from '@angular/core';

@Component({
  selector: 'app-small-spinner',
  templateUrl: './small-spinner.component.html',
  styleUrl: './small-spinner.component.scss',
  standalone: false
})
export class SmallSpinnerComponent {

}
